import React from 'react';
import LazyImage from '@/components/shared/LazyImage';
import Link from 'next/link';

interface INewsCardProps {
  src?: string | null;
  link?: string;
  sub_link?: string;
  size: 'small' | 'large' | 'default' | 'medium';
  tag?: string;
  title?: string | null;
  variant: 'horizontal' | 'vertical';
}

const NEWS_CARD_SIZES = {
  default: 'h-[171.43px]',
  large: 'h-[176px] md:h-[348px]',
  small: 'h-[140px]',
  medium: 'h-[140px]',
};

const NEWS_CARD_TITLE_SIZE = {
  default: 'text-title-medium',
  large: 'md:text-title-large text-h5 md:font-semibold',
  medium: 'text-h5',
  small: '',
};

const NEWS_CARD_LAYOUT = {
  horizontal: 'grid grid-cols-1 md:grid-cols-2 w-full',
  vertical: '',
};

const NEWS_CARD_ITEM_LAYOUT = {
  horizontal: 'p-3',
  vertical: 'px-3 py-2 md:px-1 md:py-2 flex flex-col gap-1 w-full',
};

export function NewsCard({
  src,
  size,
  link,
  sub_link,
  tag,
  title,
  variant,
}: INewsCardProps) {
  return (
    <div className={NEWS_CARD_LAYOUT[variant]}>
      {src && (
        <Link href={link || ''}>
          <div className={`relative ${NEWS_CARD_SIZES[size]} w-full`}>
            <LazyImage
              alt={''}
              fill
              className="object-fill"
              src={src || ''}
              priority={true}
              sizes="30vw"
            />
          </div>
        </Link>
      )}
      <div className={NEWS_CARD_ITEM_LAYOUT[variant]}>
        {tag && (
          <Link href={sub_link || ''}>
            <p className="text-caption-regular font-header">{tag}</p>
          </Link>
        )}
        <Link href={link || ''} className="md:h-[50px] lg:h-[60px]">
          <p
            className={`${NEWS_CARD_TITLE_SIZE[size]} hover:text-primary-eastern line-clamp-3`}
          >
            {title}
          </p>
        </Link>
      </div>
    </div>
  );
}
